/*
 * Copyright (c) 2024 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain
 * proprietary information of OCLC, Inc. and shall not be disclosed in whole or in
 * any part to any third party or used by any person for any purpose, without written
 * consent of OCLC, Inc.  Duplication of any portion of these  materials shall include this notice.
 *
 */

let intl;

export function setIntlObject(intlObject) {
  intl = intlObject;
}

export function formatMessage(id, values = {}) {
  if (!intl) {
    throw new Error(
      'Intl object is not initialized. Make sure to wrap your app with the IntlProvider and set the intl instance.',
    );
  }
  return intl.formatMessage(id, values);
}
